import React, { PureComponent } from 'react';
import { IPart } from 'types';
// Data
import storeConnect from 'data/store-connect';
import partStore, { createPart, updatePart, clonePart } from 'data/part';
// Components
import Button from 'ui/button';
import { ICON_ADD } from 'icons';
import { PartForm, PartItem, PartSelect } from 'components/part';
import styles from './board-form.scss';
import { Fade } from 'ui/transition';

interface BoardPartsProps {
  selected: string[];
}
const storeMap = {
  parts: () => partStore.list
};

@storeConnect(storeMap, [partStore])
class BoardParts extends PureComponent<BoardPartsProps> {
  state = {
    showNewPart: false
  };

  handlePartSelect = partKey => {
    this.props.onChange(this.props.selected.concat([partKey]));
  };

  handlePartSave = async(part: IPart) => {
    if (part.key) {
      updatePart(part.key, part);
    } else {
      const key = await createPart(part);
      this.props.onChange(this.props.selected.concat([key]));
    }
    this.handlePartClose();
  };

  handlePartClone = async(part: IPart) => {
    const key = await clonePart(part);
    this.props.onChange(this.props.selected.concat([key]));
    this.setState({ showPartForm: true, editPart: key });
  };
  handleNewPart = () => this.setState({ showPartForm: true, editPart: false });
  handlePartClose = () => this.setState({ showPartForm: false, editPart: false });

  render() {
    const { parts, selected } = this.props;
    const { showPartForm, editPart } = this.state;

    if (showPartForm) {
      return (
        <PartForm
          part={editPart && parts.find(p => p.key === editPart)}
          header={editPart ? 'Edit part' : 'Create new part'}
          onSave={this.handlePartSave}
          onCancel={this.handlePartClose}
        />
      );
    }
    return (
      <div>
        <div className="row">
          <div className="flex">
            <PartSelect
              onSelect={this.handlePartSelect}
              parts={parts.filter(p => selected.indexOf(p.key) === -1)}
              label="Search for parts"
              className="flex"
              clearOnSelect
            />
          </div>
          <div className="tiny-margin">
            <Button flat="New" icon={ICON_ADD} onClick={this.handleNewPart} />
          </div>
        </div>
        <div className="margin">
          {selected.length === 0 && (
            <h3 className="text-fade text-center">No parts added to board</h3>
          )}
          {selected.map(key => (
            <PartItem
              key={key}
              part={parts.find(p => p.key === key)}
              onClone={this.handlePartClone}
              onEdit={part => this.setState({ editPart: part.key, showPartForm: true })}
              onRemove={p => this.props.onChange(selected.filter(key => key !== p.key))}
            />
          ))}
        </div>
      </div>
    );
  }
}

export default BoardParts;
